import { connect } from 'react-redux';
import moment from 'moment';

import Datetimeline from './datetimeline';

const mapStateToProps = state => ({
  minutesPixelRatio: state.ux.minutesPixelRatio,
  beginDate: moment(state.ux.beginDate),
  endDate: moment(state.ux.endDate),
  view: state.ux.view,
});

export default connect(mapStateToProps, null)(Datetimeline);
